import React from 'react';
import { Search } from 'lucide-react';

const RoleFilters = ({
  searchTerm,
  setSearchTerm,
  totalRoles
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Barre de recherche */}
        <div className="flex-1 max-w-md">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
              placeholder="Rechercher un rôle..."
            />
          </div>
        </div>

        {/* Compteur */}
        <div className="text-sm text-gray-500 whitespace-nowrap">
          {totalRoles} rôle(s)
        </div>
      </div>
    </div>
  );
};

export default RoleFilters;